/**
 * Module-scope constants that upstream shares between its product surfaces.
 *
 * `tw-components.jsx` is one file, so `STOCK` and the two transition strings sit at
 * module scope and every product component reads them. Vendoring one component per file
 * would have meant three copies — `ProductCard`, `ProductRow` and `QuickLookDialog` all
 * need them — and three copies of a label set is how "In stock" in one view becomes
 * "In Stock" in another.
 *
 * `color` is the one addition beyond upstream: its list row hardcodes
 * `color: var(--success-600)` inline in the screen markup rather than using the `cls`
 * utility, because the row's stock indicator is a 9px dot with an inline colour instead
 * of a coloured icon. Keeping it here means the labels have a single source even though
 * the two surfaces render them differently.
 */
export const STOCK = {
  in: {
    label: "In stock",
    icon: "check_circle",
    cls: "text-success-600",
    color: "var(--success-600)",
  },
  low: {
    label: "Low stock",
    icon: "error",
    cls: "text-warning-600",
    color: "var(--warning-600)",
  },
  out: {
    label: "Backorder",
    icon: "schedule",
    cls: "text-ink-3",
    color: "var(--text-tertiary)",
  },
};

export const PC_ADD_TRANSITION =
  "[transition:background_var(--duration-fast),transform_var(--duration-base)_var(--ease-spring),box-shadow_var(--duration-base)_var(--ease-out)]";

export const PC_ICON_SPRING =
  "[transition:transform_var(--duration-base)_var(--ease-spring)]";
